// extracted by mini-css-extract-plugin
export default {"bottom":"Bottom_bottom__tK8wO","title":"Bottom_title__kyjJO"};